import Vue from 'vue';
import axios from 'axios';
import { MediaQueries } from 'vue-media-queries';
import VueFlashMessage from 'vue-flash-message';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import commonsStore from './common/store';
import themePlugin from './plugins/themePlugin';
import { applyCookieCredentials } from './common/authStrategy';


require('vue-flash-message/dist/vue-flash-message.min.css');

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);
Vue.use(VueFlashMessage);
Vue.use(themePlugin);

Vue.config.productionTip = false;

axios.interceptors.request.use((config) => applyCookieCredentials(config));

let loadingMajotityStorage = false;

Vue.mixin({
  beforeCreate() {
    if (!loadingMajotityStorage) {
      loadingMajotityStorage = true;
      commonsStore.restoreMandatoryStorageFromLocalToSession();
      window.addEventListener('beforeunload', commonsStore.saveMandatoryStorageToLocalStorage());
    }
  },

  beforeDestroy() {
    loadingMajotityStorage = false;
    window.removeEventListener('beforeunload', commonsStore.saveMandatoryStorageToLocalStorage());
    localStorage.clear();
  },
});

new Vue({
  router,
  store,
  vuetify,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
